module.exports = __webpack_public_path__ + "static/media/IconosGas-03.049b74bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gas/IconosGas-03.svg
// module id = 747
// module chunks = 0